import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=6763969a"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6763969a')) {
      api.createRecord('6763969a', component.options)
    } else {
      api.reload('6763969a', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=6763969a", function () {
      api.rerender('6763969a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/Menu.vue"
export default component.exports